const textDefaults = {
	'EN': {
		'welcomeTitle': 'Background Check',
		'welcomeReason': 'Please upload your CV and criminal record extract for background verification. We may ask you to clarify any employment gaps.',
		'cvUploadTitle': 'Upload Your Documents',
		'cvUploadText': 'Please upload your CV and criminal record extract (Model 596.1) for review.',
		'criminalRecordLabel': 'Criminal Record Extract (Model 596.1)',
		'gapClarificationTitle': 'Employment Gap Clarification',
		'gapClarificationText': 'We have identified gaps in your employment history. Please upload a proof document for each gap period (e.g. university enrollment, training certificate, travel receipts, or other supporting documentation).',
		'employmentGap': 'Employment Gap',
		'uploadGapProof': 'Upload proof document',
		'gapProofUploaded': 'Document uploaded',
		'gapProofInReview': 'Uploaded — will be reviewed by our team.',
		'uploading': 'Uploading...',
		'gapProofDeclinedRetry': 'This document was not accepted. Please upload a different document.',
		'uploadDifferentDocument': 'Upload a different document',
		'beforeAge18': 'Before age 18 — no proof required',
		'dateFormatWarningTitle': 'Date Format Issues',
		'dateFormatWarningText': 'Some dates in your CV are not in the expected format (DD/MM/YYYY). Please go back and upload a revised document with corrected dates.',
		'completionTitle': 'Background Check Complete',
		'completionText': 'Thank you for providing your CV and clarifications. Your background check is now complete.',
		'errorNotRecognised': 'Document not recognized',
		'errorWrongType': 'This document is not recognized as a CV. Please upload the correct document.',
		'feedbackReview': 'Provisionally accepted, pending review',
		'lblUploadOrCapture': 'Upload or take a picture',
	},
	'FR': {
		'welcomeTitle': 'Vérification des antécédents',
		'welcomeReason': 'Veuillez télécharger votre CV et votre extrait de casier judiciaire pour la vérification des antécédents. Nous pourrons vous demander de clarifier d\'éventuelles périodes d\'inactivité.',
		'cvUploadTitle': 'Téléchargez vos documents',
		'cvUploadText': 'Veuillez télécharger votre CV et votre extrait de casier judiciaire (Modèle 596.1) pour examen.',
		'criminalRecordLabel': 'Extrait de casier judiciaire (Modèle 596.1)',
		'gapClarificationTitle': 'Clarification des périodes d\'inactivité',
		'gapClarificationText': 'Nous avons identifié des périodes d\'inactivité dans votre parcours professionnel. Veuillez télécharger un justificatif pour chaque période (par ex. inscription universitaire, certificat de formation, justificatifs de voyage, ou autre document justificatif).',
		'employmentGap': 'Période d\'inactivité',
		'uploadGapProof': 'Télécharger un justificatif',
		'gapProofUploaded': 'Document téléchargé',
		'gapProofInReview': 'Téléchargé — sera examiné par notre équipe.',
		'uploading': 'Téléchargement...',
		'gapProofDeclinedRetry': 'Ce document n\'a pas été accepté. Veuillez télécharger un autre document.',
		'uploadDifferentDocument': 'Télécharger un autre document',
		'beforeAge18': 'Avant 18 ans — aucun justificatif requis',
		'dateFormatWarningTitle': 'Problèmes de format de date',
		'dateFormatWarningText': 'Certaines dates de votre CV ne sont pas au format attendu (JJ/MM/AAAA). Veuillez revenir en arrière et télécharger un document révisé avec les dates corrigées.',
		'completionTitle': 'Vérification des antécédents terminée',
		'completionText': 'Merci d\'avoir fourni votre CV et vos clarifications. Votre vérification des antécédents est maintenant terminée.',
		'errorNotRecognised': 'Document non reconnu',
		'errorWrongType': 'Ce document n\'est pas reconnu comme un CV. Veuillez télécharger le bon document.',
		'feedbackReview': 'Accepté provisoirement, en attente de révision',
		'lblUploadOrCapture': 'Téléchargez ou prenez une photo',
	},
	'DE': {
		'welcomeTitle': 'Hintergrundüberprüfung',
		'welcomeReason': 'Bitte laden Sie Ihren Lebenslauf und Strafregisterauszug zur Hintergrundüberprüfung hoch. Wir bitten Sie möglicherweise, etwaige Beschäftigungslücken zu erklären.',
		'cvUploadTitle': 'Laden Sie Ihre Dokumente hoch',
		'cvUploadText': 'Bitte laden Sie Ihren Lebenslauf und Strafregisterauszug (Modell 596.1) zur Überprüfung hoch.',
		'criminalRecordLabel': 'Strafregisterauszug (Modell 596.1)',
		'gapClarificationTitle': 'Erklärung der Beschäftigungslücken',
		'gapClarificationText': 'Wir haben Lücken in Ihrem Beschäftigungsverlauf festgestellt. Bitte laden Sie für jede Lücke ein Nachweisdokument hoch (z. B. Immatrikulationsbescheinigung, Ausbildungszertifikat, Reisebelege oder andere Nachweise).',
		'employmentGap': 'Beschäftigungslücke',
		'uploadGapProof': 'Nachweisdokument hochladen',
		'gapProofUploaded': 'Dokument hochgeladen',
		'gapProofInReview': 'Hochgeladen — wird von unserem Team überprüft.',
		'uploading': 'Hochladen...',
		'gapProofDeclinedRetry': 'Dieses Dokument wurde nicht akzeptiert. Bitte laden Sie ein anderes Dokument hoch.',
		'uploadDifferentDocument': 'Ein anderes Dokument hochladen',
		'beforeAge18': 'Vor dem 18. Lebensjahr — kein Nachweis erforderlich',
		'dateFormatWarningTitle': 'Probleme mit dem Datumsformat',
		'dateFormatWarningText': 'Einige Daten in Ihrem Lebenslauf entsprechen nicht dem erwarteten Format (TT/MM/JJJJ). Bitte gehen Sie zurück und laden Sie ein überarbeitetes Dokument mit korrigierten Daten hoch.',
		'completionTitle': 'Hintergrundüberprüfung abgeschlossen',
		'completionText': 'Vielen Dank für die Bereitstellung Ihres Lebenslaufs und Ihrer Erklärungen. Ihre Hintergrundüberprüfung ist nun abgeschlossen.',
		'errorNotRecognised': 'Dokument nicht erkannt',
		'errorWrongType': 'Dieses Dokument wird nicht als Lebenslauf erkannt. Bitte laden Sie das richtige Dokument hoch.',
		'feedbackReview': 'Vorläufig akzeptiert, ausstehende Überprüfung',
		'lblUploadOrCapture': 'Hochladen oder ein Bild aufnehmen',
	},
	'NL': {
		'welcomeTitle': 'Achtergrondcontrole',
		'welcomeReason': 'Upload alstublieft uw CV en uittreksel uit het strafregister voor achtergrondverificatie. We kunnen u vragen om eventuele werkloosheidsperioden te verduidelijken.',
		'cvUploadTitle': 'Upload Uw Documenten',
		'cvUploadText': 'Upload alstublieft uw CV en uittreksel uit het strafregister (Model 596.1) voor beoordeling.',
		'criminalRecordLabel': 'Uittreksel uit het Strafregister (Model 596.1)',
		'gapClarificationTitle': 'Verduidelijking Werkloosheidsperioden',
		'gapClarificationText': 'We hebben hiaten in uw werkgeschiedenis geïdentificeerd. Upload een bewijsdocument voor elke hiaatperiode (bijv. inschrijvingsbewijs universiteit, opleidingscertificaat, reisbonnen, of andere ondersteunende documentatie).',
		'employmentGap': 'Werkloosheidsperiode',
		'uploadGapProof': 'Upload bewijsdocument',
		'gapProofUploaded': 'Document geüpload',
		'gapProofInReview': 'Geüpload — wordt beoordeeld door ons team.',
		'uploading': 'Uploaden...',
		'gapProofDeclinedRetry': 'Dit document werd niet aanvaard. Upload een ander document.',
		'uploadDifferentDocument': 'Upload een ander document',
		'beforeAge18': 'Vóór 18 jaar — geen bewijs vereist',
		'dateFormatWarningTitle': 'Problemen met Datumformaat',
		'dateFormatWarningText': 'Sommige datums in uw CV hebben niet het verwachte formaat (DD/MM/JJJJ). Ga terug en upload een herzien document met gecorrigeerde datums.',
		'completionTitle': 'Achtergrondcontrole Voltooid',
		'completionText': 'Bedankt voor het verstrekken van uw CV en verduidelijkingen. Uw achtergrondcontrole is nu voltooid.',
		'errorNotRecognised': 'Document niet herkend',
		'errorWrongType': 'Dit document wordt niet herkend als een CV. Upload het juiste document.',
		'feedbackReview': 'Voorlopig geaccepteerd, in afwachting van beoordeling',
		'lblUploadOrCapture': 'Upload of maak een foto',
	},
	'PL': {
		'welcomeTitle': 'Weryfikacja przeszłości',
		'welcomeReason': 'Prześlij swoje CV i wyciąg z rejestru karnego w celu weryfikacji przeszłości. Możemy poprosić o wyjaśnienie ewentualnych przerw w zatrudnieniu.',
		'cvUploadTitle': 'Prześlij swoje dokumenty',
		'cvUploadText': 'Prześlij swoje CV i wyciąg z rejestru karnego (Model 596.1) do weryfikacji.',
		'criminalRecordLabel': 'Wyciąg z rejestru karnego (Model 596.1)',
		'gapClarificationTitle': 'Wyjaśnienie przerw w zatrudnieniu',
		'gapClarificationText': 'Zidentyfikowaliśmy przerwy w Twojej historii zatrudnienia. Prześlij dokument potwierdzający dla każdej przerwy (np. zaświadczenie o studiach, certyfikat szkolenia, potwierdzenia podróży lub inna dokumentacja).',
		'employmentGap': 'Przerwa w zatrudnieniu',
		'uploadGapProof': 'Prześlij dokument potwierdzający',
		'gapProofUploaded': 'Dokument przesłany',
		'gapProofInReview': 'Przesłano — zostanie zweryfikowany przez nasz zespół.',
		'uploading': 'Przesyłanie...',
		'gapProofDeclinedRetry': 'Ten dokument nie został zaakceptowany. Prześlij inny dokument.',
		'uploadDifferentDocument': 'Prześlij inny dokument',
		'beforeAge18': 'Przed 18. rokiem życia — dowód nie jest wymagany',
		'dateFormatWarningTitle': 'Problemy z formatem daty',
		'dateFormatWarningText': 'Niektóre daty w Twoim CV nie mają oczekiwanego formatu (DD/MM/RRRR). Wróć i prześlij poprawiony dokument z prawidłowymi datami.',
		'completionTitle': 'Weryfikacja przeszłości zakończona',
		'completionText': 'Dziękujemy za dostarczenie CV i wyjaśnień. Weryfikacja przeszłości jest teraz zakończona.',
		'errorNotRecognised': 'Dokument nierozpoznany',
		'errorWrongType': 'Ten dokument nie został rozpoznany jako CV. Prześlij właściwy dokument.',
		'feedbackReview': 'Tymczasowo zaakceptowano, w oczekiwaniu na weryfikację',
		'lblUploadOrCapture': 'Prześlij lub zrób zdjęcie',
	},
	'BG': {
		'welcomeTitle': 'Проверка на миналото',
		'welcomeReason': 'Моля, качете вашата автобиография и извлечение от съдебното досие за проверка на миналото. Може да ви помолим да изясните евентуални прекъсвания в заетостта.',
		'cvUploadTitle': 'Качете вашите документи',
		'cvUploadText': 'Моля, качете вашата автобиография и извлечение от съдебното досие (Модел 596.1) за преглед.',
		'criminalRecordLabel': 'Извлечение от съдебното досие (Модел 596.1)',
		'gapClarificationTitle': 'Изясняване на прекъсвания в заетостта',
		'gapClarificationText': 'Установихме прекъсвания в историята ви на заетост. Моля, качете доказателствен документ за всяко прекъсване (напр. удостоверение за записване в университет, сертификат за обучение, пътни разписки или друга подкрепяща документация).',
		'employmentGap': 'Прекъсване в заетостта',
		'uploadGapProof': 'Качете доказателствен документ',
		'gapProofUploaded': 'Документът е качен',
		'gapProofInReview': 'Качено — ще бъде прегледано от нашия екип.',
		'uploading': 'Качване...',
		'gapProofDeclinedRetry': 'Този документ не беше приет. Моля, качете друг документ.',
		'uploadDifferentDocument': 'Качете друг документ',
		'beforeAge18': 'Преди 18-годишна възраст — не се изисква доказателство',
		'dateFormatWarningTitle': 'Проблеми с формата на датата',
		'dateFormatWarningText': 'Някои дати във вашата автобиография не са в очаквания формат (ДД/ММ/ГГГГ). Моля, върнете се и качете коригиран документ с правилни дати.',
		'completionTitle': 'Проверката на миналото е завършена',
		'completionText': 'Благодарим ви, че предоставихте автобиографията и разясненията си. Проверката на миналото ви е завършена.',
		'errorNotRecognised': 'Документът не е разпознат',
		'errorWrongType': 'Този документ не е разпознат като автобиография. Моля, качете правилния документ.',
		'feedbackReview': 'Временно приет, изчаква проверка',
		'lblUploadOrCapture': 'Качете или направете снимка',
	},
	'CS': {
		'welcomeTitle': 'Ověření minulosti',
		'welcomeReason': 'Nahrajte prosím svůj životopis a výpis z rejstříku trestů pro ověření minulosti. Můžeme vás požádat o objasnění případných mezer v zaměstnání.',
		'cvUploadTitle': 'Nahrajte své dokumenty',
		'cvUploadText': 'Nahrajte prosím svůj životopis a výpis z rejstříku trestů (Model 596.1) ke kontrole.',
		'criminalRecordLabel': 'Výpis z rejstříku trestů (Model 596.1)',
		'gapClarificationTitle': 'Objasnění mezer v zaměstnání',
		'gapClarificationText': 'V historii vašeho zaměstnání jsme zjistili mezery. Nahrajte prosím doklad pro každé období mezery (např. potvrzení o studiu, certifikát o školení, cestovní doklady nebo jinou podpůrnou dokumentaci).',
		'employmentGap': 'Mezera v zaměstnání',
		'uploadGapProof': 'Nahrát doklad',
		'gapProofUploaded': 'Dokument nahrán',
		'gapProofInReview': 'Nahráno — bude zkontrolováno naším týmem.',
		'uploading': 'Nahrávání...',
		'gapProofDeclinedRetry': 'Tento dokument nebyl přijat. Nahrajte prosím jiný dokument.',
		'uploadDifferentDocument': 'Nahrát jiný dokument',
		'beforeAge18': 'Před 18. rokem — doklad není vyžadován',
		'dateFormatWarningTitle': 'Problémy s formátem data',
		'dateFormatWarningText': 'Některá data ve vašem životopisu nemají očekávaný formát (DD/MM/RRRR). Vraťte se prosím a nahrajte opravený dokument se správnými daty.',
		'completionTitle': 'Ověření minulosti dokončeno',
		'completionText': 'Děkujeme za poskytnutí životopisu a vysvětlení. Vaše ověření minulosti je nyní dokončeno.',
		'errorNotRecognised': 'Dokument nerozpoznán',
		'errorWrongType': 'Tento dokument nebyl rozpoznán jako životopis. Nahrajte prosím správný dokument.',
		'feedbackReview': 'Předběžně přijato, čeká na kontrolu',
		'lblUploadOrCapture': 'Nahrát nebo pořídit obrázek',
	},
	'DA': {
		'welcomeTitle': 'Baggrundstjek',
		'welcomeReason': 'Upload venligst dit CV og straffeattestuddrag til baggrundsverifikation. Vi kan bede dig om at forklare eventuelle huller i din beskæftigelse.',
		'cvUploadTitle': 'Upload dine dokumenter',
		'cvUploadText': 'Upload venligst dit CV og straffeattestuddrag (Model 596.1) til gennemgang.',
		'criminalRecordLabel': 'Straffeattestuddrag (Model 596.1)',
		'gapClarificationTitle': 'Forklaring af beskæftigelseshuller',
		'gapClarificationText': 'Vi har identificeret huller i din beskæftigelseshistorik. Upload venligst dokumentation for hver periode (f.eks. universitetsindskrivning, uddannelsescertifikat, rejsekvitteringer eller anden dokumentation).',
		'employmentGap': 'Beskæftigelseshul',
		'uploadGapProof': 'Upload dokumentation',
		'gapProofUploaded': 'Dokument uploadet',
		'gapProofInReview': 'Uploadet — vil blive gennemgået af vores team.',
		'uploading': 'Uploader...',
		'gapProofDeclinedRetry': 'Dette dokument blev ikke accepteret. Upload venligst et andet dokument.',
		'uploadDifferentDocument': 'Upload et andet dokument',
		'beforeAge18': 'Før 18 år — ingen dokumentation påkrævet',
		'dateFormatWarningTitle': 'Problemer med datoformat',
		'dateFormatWarningText': 'Nogle datoer i dit CV har ikke det forventede format (DD/MM/ÅÅÅÅ). Gå venligst tilbage og upload et revideret dokument med korrigerede datoer.',
		'completionTitle': 'Baggrundstjek afsluttet',
		'completionText': 'Tak for dit CV og dine forklaringer. Dit baggrundstjek er nu afsluttet.',
		'errorNotRecognised': 'Dokument ikke genkendt',
		'errorWrongType': 'Dette dokument er ikke genkendt som et CV. Upload venligst det korrekte dokument.',
		'feedbackReview': 'Foreløbigt accepteret, afventer gennemgang',
		'lblUploadOrCapture': 'Upload eller tag et billede',
	},
	'ES': {
		'welcomeTitle': 'Verificación de antecedentes',
		'welcomeReason': 'Por favor suba su CV y extracto de antecedentes penales para la verificación de antecedentes. Es posible que le pidamos aclarar cualquier brecha laboral.',
		'cvUploadTitle': 'Suba sus documentos',
		'cvUploadText': 'Por favor suba su CV y extracto de antecedentes penales (Modelo 596.1) para revisión.',
		'criminalRecordLabel': 'Extracto de antecedentes penales (Modelo 596.1)',
		'gapClarificationTitle': 'Aclaración de brechas laborales',
		'gapClarificationText': 'Hemos identificado brechas en su historial laboral. Por favor suba un documento justificativo para cada período (por ej. matrícula universitaria, certificado de formación, comprobantes de viaje u otra documentación de respaldo).',
		'employmentGap': 'Brecha laboral',
		'uploadGapProof': 'Subir documento justificativo',
		'gapProofUploaded': 'Documento subido',
		'gapProofInReview': 'Subido — será revisado por nuestro equipo.',
		'uploading': 'Subiendo...',
		'gapProofDeclinedRetry': 'Este documento no fue aceptado. Por favor suba un documento diferente.',
		'uploadDifferentDocument': 'Subir un documento diferente',
		'beforeAge18': 'Antes de los 18 años — no se requiere justificante',
		'dateFormatWarningTitle': 'Problemas con el formato de fecha',
		'dateFormatWarningText': 'Algunas fechas de su CV no tienen el formato esperado (DD/MM/AAAA). Por favor vuelva atrás y suba un documento revisado con las fechas corregidas.',
		'completionTitle': 'Verificación de antecedentes completada',
		'completionText': 'Gracias por proporcionar su CV y aclaraciones. Su verificación de antecedentes ha finalizado.',
		'errorNotRecognised': 'Documento no reconocido',
		'errorWrongType': 'Este documento no se reconoce como un CV. Por favor suba el documento correcto.',
		'feedbackReview': 'Aceptado provisionalmente, pendiente de revisión',
		'lblUploadOrCapture': 'Sube o toma una foto',
	},
	'FI': {
		'welcomeTitle': 'Taustatarkistus',
		'welcomeReason': 'Lataa ansioluettelosi ja rikosrekisteriote taustatarkistusta varten. Saatamme pyytää sinua selventämään mahdollisia työsuhteen katkoja.',
		'cvUploadTitle': 'Lataa asiakirjasi',
		'cvUploadText': 'Lataa ansioluettelosi ja rikosrekisteriote (Malli 596.1) tarkistettavaksi.',
		'criminalRecordLabel': 'Rikosrekisteriote (Malli 596.1)',
		'gapClarificationTitle': 'Työsuhdekatkoksien selvitys',
		'gapClarificationText': 'Olemme havainneet katkoksia työhistoriassasi. Lataa todistusasiakirja jokaisesta katkoksen ajanjaksosta (esim. yliopistoon ilmoittautuminen, koulutustodistus, matkakuitit tai muu todistusaineisto).',
		'employmentGap': 'Työsuhdekatkos',
		'uploadGapProof': 'Lataa todistusasiakirja',
		'gapProofUploaded': 'Asiakirja ladattu',
		'gapProofInReview': 'Ladattu — tiimimme tarkistaa sen.',
		'uploading': 'Ladataan...',
		'gapProofDeclinedRetry': 'Tätä asiakirjaa ei hyväksytty. Lataa eri asiakirja.',
		'uploadDifferentDocument': 'Lataa eri asiakirja',
		'beforeAge18': 'Ennen 18 vuoden ikää — todistusta ei vaadita',
		'dateFormatWarningTitle': 'Päivämäärämuoto-ongelmat',
		'dateFormatWarningText': 'Jotkin ansioluettelosi päivämäärät eivät ole odotetussa muodossa (PP/KK/VVVV). Palaa takaisin ja lataa korjattu asiakirja oikeilla päivämäärillä.',
		'completionTitle': 'Taustatarkistus valmis',
		'completionText': 'Kiitos ansioluettelosi ja selvityksesi toimittamisesta. Taustatarkistuksesi on nyt valmis.',
		'errorNotRecognised': 'Asiakirjaa ei tunnistettu',
		'errorWrongType': 'Tätä asiakirjaa ei tunnistettu ansioluetteloksi. Lataa oikea asiakirja.',
		'feedbackReview': 'Ehdollisesti hyväksytty, odottaa tarkistusta',
		'lblUploadOrCapture': 'Lataa tai ota kuva',
	},
	'HR': {
		'welcomeTitle': 'Provjera prošlosti',
		'welcomeReason': 'Molimo učitajte svoj životopis i izvadak iz kaznene evidencije za provjeru prošlosti. Možemo vas zamoliti da pojasnite eventualne praznine u zaposlenju.',
		'cvUploadTitle': 'Učitajte svoje dokumente',
		'cvUploadText': 'Molimo učitajte svoj životopis i izvadak iz kaznene evidencije (Model 596.1) na pregled.',
		'criminalRecordLabel': 'Izvadak iz kaznene evidencije (Model 596.1)',
		'gapClarificationTitle': 'Pojašnjenje praznina u zaposlenju',
		'gapClarificationText': 'Identificirali smo praznine u vašoj povijesti zaposlenja. Molimo učitajte dokazni dokument za svako razdoblje praznine (npr. upis na fakultet, certifikat o osposobljavanju, putne račune ili drugu popratnu dokumentaciju).',
		'employmentGap': 'Praznina u zaposlenju',
		'uploadGapProof': 'Učitaj dokazni dokument',
		'gapProofUploaded': 'Dokument učitan',
		'gapProofInReview': 'Učitano — bit će pregledano od strane našeg tima.',
		'uploading': 'Učitavanje...',
		'gapProofDeclinedRetry': 'Ovaj dokument nije prihvaćen. Molimo učitajte drugi dokument.',
		'uploadDifferentDocument': 'Učitaj drugi dokument',
		'beforeAge18': 'Prije 18. godine — dokaz nije potreban',
		'dateFormatWarningTitle': 'Problemi s formatom datuma',
		'dateFormatWarningText': 'Neki datumi u vašem životopisu nisu u očekivanom formatu (DD/MM/GGGG). Molimo vratite se i učitajte ispravljeni dokument s točnim datumima.',
		'completionTitle': 'Provjera prošlosti završena',
		'completionText': 'Hvala što ste dostavili svoj životopis i pojašnjenja. Vaša provjera prošlosti je sada završena.',
		'errorNotRecognised': 'Dokument nije prepoznat',
		'errorWrongType': 'Ovaj dokument nije prepoznat kao životopis. Molimo učitajte ispravan dokument.',
		'feedbackReview': 'Uvjetno prihvaćeno, čeka pregled',
		'lblUploadOrCapture': 'Učitaj ili snimi sliku',
	},
	'HU': {
		'welcomeTitle': 'Háttérellenőrzés',
		'welcomeReason': 'Kérjük, töltse fel önéletrajzát és bűnügyi nyilvántartási kivonatát a háttérellenőrzéshez. Kérhetjük, hogy tisztázza az esetleges foglalkoztatási hiányokat.',
		'cvUploadTitle': 'Töltse fel dokumentumait',
		'cvUploadText': 'Kérjük, töltse fel önéletrajzát és bűnügyi nyilvántartási kivonatát (596.1 modell) ellenőrzésre.',
		'criminalRecordLabel': 'Bűnügyi nyilvántartási kivonat (596.1 modell)',
		'gapClarificationTitle': 'Foglalkoztatási hiányok tisztázása',
		'gapClarificationText': 'Hiányokat azonosítottunk a foglalkoztatási előzményeiben. Kérjük, töltsön fel igazoló dokumentumot minden egyes időszakra (pl. egyetemi beiratkozás, képzési tanúsítvány, utazási bizonylatok vagy egyéb igazoló dokumentáció).',
		'employmentGap': 'Foglalkoztatási hiány',
		'uploadGapProof': 'Igazoló dokumentum feltöltése',
		'gapProofUploaded': 'Dokumentum feltöltve',
		'gapProofInReview': 'Feltöltve — csapatunk felülvizsgálja.',
		'uploading': 'Feltöltés...',
		'gapProofDeclinedRetry': 'Ezt a dokumentumot nem fogadták el. Kérjük, töltsön fel egy másik dokumentumot.',
		'uploadDifferentDocument': 'Másik dokumentum feltöltése',
		'beforeAge18': '18 éves kor előtt — igazolás nem szükséges',
		'dateFormatWarningTitle': 'Dátumformátum-problémák',
		'dateFormatWarningText': 'Az önéletrajzában szereplő egyes dátumok nem a várt formátumban vannak (NN/HH/ÉÉÉÉ). Kérjük, menjen vissza és töltsön fel egy javított dokumentumot a helyes dátumokkal.',
		'completionTitle': 'Háttérellenőrzés befejezve',
		'completionText': 'Köszönjük, hogy megadta önéletrajzát és tisztázásait. A háttérellenőrzés befejeződött.',
		'errorNotRecognised': 'Dokumentum nem felismerhető',
		'errorWrongType': 'Ez a dokumentum nem ismerhető fel önéletrajzként. Kérjük, töltse fel a megfelelő dokumentumot.',
		'feedbackReview': 'Ideiglenesen elfogadva, felülvizsgálatra vár',
		'lblUploadOrCapture': 'Feltöltés vagy fénykép készítése',
	},
	'IT': {
		'welcomeTitle': 'Verifica dei precedenti',
		'welcomeReason': 'Carica il tuo CV e l\'estratto del casellario giudiziale per la verifica dei precedenti. Potremmo chiederti di chiarire eventuali lacune occupazionali.',
		'cvUploadTitle': 'Carica i tuoi documenti',
		'cvUploadText': 'Carica il tuo CV e l\'estratto del casellario giudiziale (Modello 596.1) per la revisione.',
		'criminalRecordLabel': 'Estratto del casellario giudiziale (Modello 596.1)',
		'gapClarificationTitle': 'Chiarimento delle lacune occupazionali',
		'gapClarificationText': 'Abbiamo identificato delle lacune nella tua storia lavorativa. Carica un documento giustificativo per ogni periodo (ad es. iscrizione universitaria, certificato di formazione, ricevute di viaggio o altra documentazione di supporto).',
		'employmentGap': 'Lacuna occupazionale',
		'uploadGapProof': 'Carica documento giustificativo',
		'gapProofUploaded': 'Documento caricato',
		'gapProofInReview': 'Caricato — sarà esaminato dal nostro team.',
		'uploading': 'Caricamento...',
		'gapProofDeclinedRetry': 'Questo documento non è stato accettato. Carica un documento diverso.',
		'uploadDifferentDocument': 'Carica un documento diverso',
		'beforeAge18': 'Prima dei 18 anni — nessuna prova richiesta',
		'dateFormatWarningTitle': 'Problemi con il formato della data',
		'dateFormatWarningText': 'Alcune date nel tuo CV non sono nel formato previsto (GG/MM/AAAA). Torna indietro e carica un documento rivisto con le date corrette.',
		'completionTitle': 'Verifica dei precedenti completata',
		'completionText': 'Grazie per aver fornito il tuo CV e i chiarimenti. La verifica dei precedenti è ora completata.',
		'errorNotRecognised': 'Documento non riconosciuto',
		'errorWrongType': 'Questo documento non è riconosciuto come CV. Carica il documento corretto.',
		'feedbackReview': 'Accettato provvisoriamente, in attesa di revisione',
		'lblUploadOrCapture': 'Carica o scatta una foto',
	},
	'NO': {
		'welcomeTitle': 'Bakgrunnssjekk',
		'welcomeReason': 'Last opp din CV og utdrag fra strafferegisteret for bakgrunnsverifisering. Vi kan be deg om å forklare eventuelle hull i ansettelseshistorikken.',
		'cvUploadTitle': 'Last opp dine dokumenter',
		'cvUploadText': 'Last opp din CV og utdrag fra strafferegisteret (Modell 596.1) for gjennomgang.',
		'criminalRecordLabel': 'Utdrag fra strafferegisteret (Modell 596.1)',
		'gapClarificationTitle': 'Forklaring av ansettelseshull',
		'gapClarificationText': 'Vi har identifisert hull i din ansettelseshistorikk. Last opp et bekreftelsesdokument for hver periode (f.eks. universitetsinnskriving, opplæringssertifikat, reisekvitteringer eller annen støttedokumentasjon).',
		'employmentGap': 'Ansettelseshull',
		'uploadGapProof': 'Last opp bekreftelsesdokument',
		'gapProofUploaded': 'Dokument lastet opp',
		'gapProofInReview': 'Lastet opp — vil bli gjennomgått av vårt team.',
		'uploading': 'Laster opp...',
		'gapProofDeclinedRetry': 'Dette dokumentet ble ikke akseptert. Last opp et annet dokument.',
		'uploadDifferentDocument': 'Last opp et annet dokument',
		'beforeAge18': 'Før 18 år — ingen dokumentasjon kreves',
		'dateFormatWarningTitle': 'Problemer med datoformat',
		'dateFormatWarningText': 'Noen datoer i din CV er ikke i forventet format (DD/MM/ÅÅÅÅ). Gå tilbake og last opp et revidert dokument med korrigerte datoer.',
		'completionTitle': 'Bakgrunnssjekk fullført',
		'completionText': 'Takk for at du har levert din CV og forklaringer. Din bakgrunnssjekk er nå fullført.',
		'errorNotRecognised': 'Dokument ikke gjenkjent',
		'errorWrongType': 'Dette dokumentet er ikke gjenkjent som en CV. Last opp riktig dokument.',
		'feedbackReview': 'Foreløpig akseptert, venter på gjennomgang',
		'lblUploadOrCapture': 'Last opp eller ta et bilde',
	},
	'PT': {
		'welcomeTitle': 'Verificação de antecedentes',
		'welcomeReason': 'Por favor carregue o seu CV e extrato do registo criminal para verificação de antecedentes. Poderemos pedir que esclareça eventuais lacunas no emprego.',
		'cvUploadTitle': 'Carregue os seus documentos',
		'cvUploadText': 'Por favor carregue o seu CV e extrato do registo criminal (Modelo 596.1) para análise.',
		'criminalRecordLabel': 'Extrato do registo criminal (Modelo 596.1)',
		'gapClarificationTitle': 'Esclarecimento de lacunas no emprego',
		'gapClarificationText': 'Identificámos lacunas no seu histórico de emprego. Por favor carregue um documento comprovativo para cada período (ex. inscrição universitária, certificado de formação, recibos de viagem ou outra documentação de suporte).',
		'employmentGap': 'Lacuna no emprego',
		'uploadGapProof': 'Carregar documento comprovativo',
		'gapProofUploaded': 'Documento carregado',
		'gapProofInReview': 'Carregado — será analisado pela nossa equipa.',
		'uploading': 'A carregar...',
		'gapProofDeclinedRetry': 'Este documento não foi aceite. Por favor carregue um documento diferente.',
		'uploadDifferentDocument': 'Carregar um documento diferente',
		'beforeAge18': 'Antes dos 18 anos — sem comprovativo necessário',
		'dateFormatWarningTitle': 'Problemas com o formato de data',
		'dateFormatWarningText': 'Algumas datas no seu CV não estão no formato esperado (DD/MM/AAAA). Por favor volte atrás e carregue um documento revisto com as datas corrigidas.',
		'completionTitle': 'Verificação de antecedentes concluída',
		'completionText': 'Obrigado por fornecer o seu CV e esclarecimentos. A sua verificação de antecedentes está agora concluída.',
		'errorNotRecognised': 'Documento não reconhecido',
		'errorWrongType': 'Este documento não é reconhecido como um CV. Por favor carregue o documento correto.',
		'feedbackReview': 'Aceite provisoriamente, aguardando revisão',
		'lblUploadOrCapture': 'Carregar ou tirar uma foto',
	},
	'RO': {
		'welcomeTitle': 'Verificare de fond',
		'welcomeReason': 'Vă rugăm să încărcați CV-ul dvs. și extrasul din cazierul judiciar pentru verificarea de fond. S-ar putea să vă solicităm clarificări privind eventualele pauze în angajare.',
		'cvUploadTitle': 'Încărcați documentele dvs.',
		'cvUploadText': 'Vă rugăm să încărcați CV-ul dvs. și extrasul din cazierul judiciar (Model 596.1) pentru examinare.',
		'criminalRecordLabel': 'Extras din cazierul judiciar (Model 596.1)',
		'gapClarificationTitle': 'Clarificarea pauzelor în angajare',
		'gapClarificationText': 'Am identificat pauze în istoricul dvs. de angajare. Vă rugăm să încărcați un document justificativ pentru fiecare perioadă (de ex. adeverință de înscriere la universitate, certificat de formare, chitanțe de călătorie sau altă documentație justificativă).',
		'employmentGap': 'Pauză în angajare',
		'uploadGapProof': 'Încărcați document justificativ',
		'gapProofUploaded': 'Document încărcat',
		'gapProofInReview': 'Încărcat — va fi examinat de echipa noastră.',
		'uploading': 'Se încarcă...',
		'gapProofDeclinedRetry': 'Acest document nu a fost acceptat. Vă rugăm să încărcați un alt document.',
		'uploadDifferentDocument': 'Încărcați un alt document',
		'beforeAge18': 'Înainte de 18 ani — nu este necesar niciun document',
		'dateFormatWarningTitle': 'Probleme cu formatul datei',
		'dateFormatWarningText': 'Unele date din CV-ul dvs. nu sunt în formatul așteptat (ZZ/LL/AAAA). Vă rugăm să reveniți și să încărcați un document revizuit cu datele corectate.',
		'completionTitle': 'Verificare de fond finalizată',
		'completionText': 'Vă mulțumim pentru furnizarea CV-ului și clarificărilor. Verificarea dvs. de fond este acum finalizată.',
		'errorNotRecognised': 'Document nerecunoscut',
		'errorWrongType': 'Acest document nu este recunoscut ca un CV. Vă rugăm să încărcați documentul corect.',
		'feedbackReview': 'Acceptat provizoriu, în așteptarea revizuirii',
		'lblUploadOrCapture': 'Încărcați sau faceți o fotografie',
	},
	'RU': {
		'welcomeTitle': 'Проверка биографии',
		'welcomeReason': 'Пожалуйста, загрузите ваше резюме и выписку из реестра судимостей для проверки биографии. Мы можем попросить вас пояснить возможные перерывы в трудовой деятельности.',
		'cvUploadTitle': 'Загрузите ваши документы',
		'cvUploadText': 'Пожалуйста, загрузите ваше резюме и выписку из реестра судимостей (Модель 596.1) для проверки.',
		'criminalRecordLabel': 'Выписка из реестра судимостей (Модель 596.1)',
		'gapClarificationTitle': 'Пояснение перерывов в трудовой деятельности',
		'gapClarificationText': 'Мы обнаружили перерывы в вашей трудовой истории. Пожалуйста, загрузите подтверждающий документ для каждого периода (например, справку о зачислении в университет, сертификат обучения, квитанции о путешествиях или другую подтверждающую документацию).',
		'employmentGap': 'Перерыв в трудовой деятельности',
		'uploadGapProof': 'Загрузить подтверждающий документ',
		'gapProofUploaded': 'Документ загружен',
		'gapProofInReview': 'Загружено — будет проверено нашей командой.',
		'uploading': 'Загрузка...',
		'gapProofDeclinedRetry': 'Этот документ не был принят. Пожалуйста, загрузите другой документ.',
		'uploadDifferentDocument': 'Загрузить другой документ',
		'beforeAge18': 'До 18 лет — подтверждение не требуется',
		'dateFormatWarningTitle': 'Проблемы с форматом дат',
		'dateFormatWarningText': 'Некоторые даты в вашем резюме не соответствуют ожидаемому формату (ДД/ММ/ГГГГ). Пожалуйста, вернитесь и загрузите исправленный документ с правильными датами.',
		'completionTitle': 'Проверка биографии завершена',
		'completionText': 'Спасибо за предоставление вашего резюме и пояснений. Проверка вашей биографии завершена.',
		'errorNotRecognised': 'Документ не распознан',
		'errorWrongType': 'Этот документ не распознан как резюме. Пожалуйста, загрузите правильный документ.',
		'feedbackReview': 'Временно принят, ожидает проверки',
		'lblUploadOrCapture': 'Загрузить или сделать фото',
	},
	'SK': {
		'welcomeTitle': 'Overenie minulosti',
		'welcomeReason': 'Nahrajte prosím svoj životopis a výpis z registra trestov na overenie minulosti. Môžeme vás požiadať o objasnenie prípadných medzier v zamestnaní.',
		'cvUploadTitle': 'Nahrajte svoje dokumenty',
		'cvUploadText': 'Nahrajte prosím svoj životopis a výpis z registra trestov (Model 596.1) na kontrolu.',
		'criminalRecordLabel': 'Výpis z registra trestov (Model 596.1)',
		'gapClarificationTitle': 'Objasnenie medzier v zamestnaní',
		'gapClarificationText': 'V histórii vášho zamestnania sme zistili medzery. Nahrajte prosím doklad pre každé obdobie medzery (napr. potvrdenie o štúdiu, certifikát o školení, cestovné doklady alebo inú podpornú dokumentáciu).',
		'employmentGap': 'Medzera v zamestnaní',
		'uploadGapProof': 'Nahrať doklad',
		'gapProofUploaded': 'Dokument nahraný',
		'gapProofInReview': 'Nahrané — bude skontrolované naším tímom.',
		'uploading': 'Nahrávanie...',
		'gapProofDeclinedRetry': 'Tento dokument nebol prijatý. Nahrajte prosím iný dokument.',
		'uploadDifferentDocument': 'Nahrať iný dokument',
		'beforeAge18': 'Pred 18. rokom — doklad nie je vyžadovaný',
		'dateFormatWarningTitle': 'Problémy s formátom dátumu',
		'dateFormatWarningText': 'Niektoré dátumy vo vašom životopise nemajú očakávaný formát (DD/MM/RRRR). Vráťte sa prosím a nahrajte opravený dokument so správnymi dátumami.',
		'completionTitle': 'Overenie minulosti dokončené',
		'completionText': 'Ďakujeme za poskytnutie životopisu a vysvetlení. Vaše overenie minulosti je teraz dokončené.',
		'errorNotRecognised': 'Dokument nebol rozpoznaný',
		'errorWrongType': 'Tento dokument nebol rozpoznaný ako životopis. Nahrajte prosím správny dokument.',
		'feedbackReview': 'Predbežne akceptovaný, čaká na kontrolu',
		'lblUploadOrCapture': 'Nahrať alebo urobiť obrázok',
	},
	'SI': {
		'welcomeTitle': 'Preverjanje ozadja',
		'welcomeReason': 'Prosimo, naložite svoj življenjepis in izpisek iz kazenske evidence za preverjanje ozadja. Morda vas bomo prosili, da pojasnite morebitne vrzeli v zaposlitvi.',
		'cvUploadTitle': 'Naložite svoje dokumente',
		'cvUploadText': 'Prosimo, naložite svoj življenjepis in izpisek iz kazenske evidence (Model 596.1) v pregled.',
		'criminalRecordLabel': 'Izpisek iz kazenske evidence (Model 596.1)',
		'gapClarificationTitle': 'Pojasnitev vrzeli v zaposlitvi',
		'gapClarificationText': 'V vaši zgodovini zaposlitve smo odkrili vrzeli. Prosimo, naložite dokazilo za vsako obdobje vrzeli (npr. potrdilo o vpisu na univerzo, certifikat o usposabljanju, potrdila o potovanju ali drugo podporno dokumentacijo).',
		'employmentGap': 'Vrzel v zaposlitvi',
		'uploadGapProof': 'Naloži dokazilo',
		'gapProofUploaded': 'Dokument naložen',
		'gapProofInReview': 'Naloženo — bo pregledano s strani naše ekipe.',
		'uploading': 'Nalaganje...',
		'gapProofDeclinedRetry': 'Ta dokument ni bil sprejet. Prosimo, naložite drug dokument.',
		'uploadDifferentDocument': 'Naloži drug dokument',
		'beforeAge18': 'Pred 18. letom — dokazilo ni potrebno',
		'dateFormatWarningTitle': 'Težave z obliko datuma',
		'dateFormatWarningText': 'Nekateri datumi v vašem življenjepisu niso v pričakovani obliki (DD/MM/LLLL). Prosimo, vrnite se in naložite popravljen dokument s pravilnimi datumi.',
		'completionTitle': 'Preverjanje ozadja zaključeno',
		'completionText': 'Hvala, da ste zagotovili svoj življenjepis in pojasnila. Vaše preverjanje ozadja je zdaj zaključeno.',
		'errorNotRecognised': 'Dokument ni prepoznan',
		'errorWrongType': 'Ta dokument ni prepoznan kot življenjepis. Prosimo, naložite pravilen dokument.',
		'feedbackReview': 'Začasno sprejeto, čaka na pregled',
		'lblUploadOrCapture': 'Naložite ali naredite fotografijo',
	},
	'SV': {
		'welcomeTitle': 'Bakgrundskontroll',
		'welcomeReason': 'Ladda upp ditt CV och utdrag ur belastningsregistret för bakgrundsverifiering. Vi kan be dig att förklara eventuella luckor i din anställningshistorik.',
		'cvUploadTitle': 'Ladda upp dina dokument',
		'cvUploadText': 'Ladda upp ditt CV och utdrag ur belastningsregistret (Modell 596.1) för granskning.',
		'criminalRecordLabel': 'Utdrag ur belastningsregistret (Modell 596.1)',
		'gapClarificationTitle': 'Förklaring av anställningsluckor',
		'gapClarificationText': 'Vi har identifierat luckor i din anställningshistorik. Ladda upp ett styrkande dokument för varje period (t.ex. universitetsinskrivning, utbildningscertifikat, resekvitton eller annan styrkande dokumentation).',
		'employmentGap': 'Anställningslucka',
		'uploadGapProof': 'Ladda upp styrkande dokument',
		'gapProofUploaded': 'Dokument uppladdat',
		'gapProofInReview': 'Uppladdat — kommer att granskas av vårt team.',
		'uploading': 'Laddar upp...',
		'gapProofDeclinedRetry': 'Detta dokument godkändes inte. Ladda upp ett annat dokument.',
		'uploadDifferentDocument': 'Ladda upp ett annat dokument',
		'beforeAge18': 'Före 18 års ålder — inget intyg krävs',
		'dateFormatWarningTitle': 'Problem med datumformat',
		'dateFormatWarningText': 'Vissa datum i ditt CV är inte i förväntat format (DD/MM/ÅÅÅÅ). Gå tillbaka och ladda upp ett reviderat dokument med korrigerade datum.',
		'completionTitle': 'Bakgrundskontroll slutförd',
		'completionText': 'Tack för att du tillhandahållit ditt CV och förtydliganden. Din bakgrundskontroll är nu slutförd.',
		'errorNotRecognised': 'Dokument inte igenkänt',
		'errorWrongType': 'Detta dokument känns inte igen som ett CV. Ladda upp korrekt dokument.',
		'feedbackReview': 'Villkorligt godkänd, väntar på granskning',
		'lblUploadOrCapture': 'Ladda upp eller ta en bild',
	},
	'TR': {
		'welcomeTitle': 'Geçmiş kontrolü',
		'welcomeReason': 'Geçmiş doğrulaması için özgeçmişinizi ve adli sicil kaydı özetinizi yükleyin. İstihdam boşluklarını açıklamanızı isteyebiliriz.',
		'cvUploadTitle': 'Belgelerinizi yükleyin',
		'cvUploadText': 'Lütfen özgeçmişinizi ve adli sicil kaydı özetinizi (Model 596.1) incelenmek üzere yükleyin.',
		'criminalRecordLabel': 'Adli sicil kaydı özeti (Model 596.1)',
		'gapClarificationTitle': 'İstihdam boşluklarının açıklanması',
		'gapClarificationText': 'İstihdam geçmişinizde boşluklar tespit ettik. Lütfen her boşluk dönemi için kanıt belgesi yükleyin (örn. üniversite kaydı, eğitim sertifikası, seyahat makbuzları veya diğer destekleyici belgeler).',
		'employmentGap': 'İstihdam boşluğu',
		'uploadGapProof': 'Kanıt belgesi yükle',
		'gapProofUploaded': 'Belge yüklendi',
		'gapProofInReview': 'Yüklendi — ekibimiz tarafından incelenecek.',
		'uploading': 'Yükleniyor...',
		'gapProofDeclinedRetry': 'Bu belge kabul edilmedi. Lütfen farklı bir belge yükleyin.',
		'uploadDifferentDocument': 'Farklı bir belge yükle',
		'beforeAge18': '18 yaşından önce — kanıt gerekli değil',
		'dateFormatWarningTitle': 'Tarih formatı sorunları',
		'dateFormatWarningText': 'Özgeçmişinizdeki bazı tarihler beklenen formatta değil (GG/AA/YYYY). Lütfen geri dönün ve düzeltilmiş tarihlerle revize edilmiş bir belge yükleyin.',
		'completionTitle': 'Geçmiş kontrolü tamamlandı',
		'completionText': 'Özgeçmişinizi ve açıklamalarınızı sağladığınız için teşekkür ederiz. Geçmiş kontrolünüz tamamlanmıştır.',
		'errorNotRecognised': 'Belge tanınmadı',
		'errorWrongType': 'Bu belge özgeçmiş olarak tanınmadı. Lütfen doğru belgeyi yükleyin.',
		'feedbackReview': 'Geçici olarak kabul edildi, inceleme bekleniyor',
		'lblUploadOrCapture': 'Yükle veya fotoğraf çek',
	},
	'UK': {
		'welcomeTitle': 'Перевірка біографії',
		'welcomeReason': 'Будь ласка, завантажте ваше резюме та витяг з реєстру судимостей для перевірки біографії. Ми можемо попросити вас пояснити можливі перерви у трудовій діяльності.',
		'cvUploadTitle': 'Завантажте ваші документи',
		'cvUploadText': 'Будь ласка, завантажте ваше резюме та витяг з реєстру судимостей (Модель 596.1) для перевірки.',
		'criminalRecordLabel': 'Витяг з реєстру судимостей (Модель 596.1)',
		'gapClarificationTitle': 'Пояснення перерв у трудовій діяльності',
		'gapClarificationText': 'Ми виявили перерви у вашій трудовій історії. Будь ласка, завантажте підтверджуючий документ для кожного періоду (наприклад, довідку про зарахування до університету, сертифікат навчання, квитанції про подорожі або іншу підтверджуючу документацію).',
		'employmentGap': 'Перерва у трудовій діяльності',
		'uploadGapProof': 'Завантажити підтверджуючий документ',
		'gapProofUploaded': 'Документ завантажено',
		'gapProofInReview': 'Завантажено — буде перевірено нашою командою.',
		'uploading': 'Завантаження...',
		'gapProofDeclinedRetry': 'Цей документ не було прийнято. Будь ласка, завантажте інший документ.',
		'uploadDifferentDocument': 'Завантажити інший документ',
		'beforeAge18': 'До 18 років — підтвердження не потрібне',
		'dateFormatWarningTitle': 'Проблеми з форматом дат',
		'dateFormatWarningText': 'Деякі дати у вашому резюме не відповідають очікуваному формату (ДД/ММ/РРРР). Будь ласка, поверніться та завантажте виправлений документ з правильними датами.',
		'completionTitle': 'Перевірку біографії завершено',
		'completionText': 'Дякуємо за надання вашого резюме та пояснень. Перевірку вашої біографії завершено.',
		'errorNotRecognised': 'Документ не розпізнано',
		'errorWrongType': 'Цей документ не розпізнано як резюме. Будь ласка, завантажте правильний документ.',
		'feedbackReview': 'Тимчасово прийнято, очікує перевірки',
		'lblUploadOrCapture': 'Завантажити або зробити фото',
	},
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
